import { httpClient } from '../lib/httpClient';
import type { ComplianceActivity } from '../types/complianceWorkflow';

export async function getClientActivity(clientId: string, params?: { limit?: number; offset?: number; event_type?: string }) {
  return httpClient.get<{ items: ComplianceActivity[]; total: number }>(`/api/compliance/activity/${clientId}`, { params });
}

export async function getActivitySummary(clientId: string) {
  return httpClient.get<Record<string, number>>(`/api/compliance/activity/${clientId}/summary`);
}

// TASK-483: account-level compliance overview stats for the dashboard hero row.
export interface ComplianceSummary {
  pending_reviews: number;
  risk_alerts: number;
  documents_verified: number;
  compliance_score: number | null; // null when there's no compliance basis yet
}

export async function getComplianceSummary() {
  return httpClient.get<ComplianceSummary & { success: boolean }>('/api/compliance/summary');
}

// TASK-517: FinSA/MiFID suitability form-selection engine (compliance-service).
export interface RequiredForm {
  form_id: string;
  form_name: string;
  regulation: string;
  priority: string;
  status: string;
  fields_count: number;
  supports_aggregation: boolean;
}

export interface AnalysisResponse {
  proposal_id: string;
  analysis_timestamp: string;
  required_forms: RequiredForm[];
  aggregations: Record<string, unknown>;
  compliance_score: number;
  is_compliant: boolean;
  warnings: string[];
  info: string[];
  special_requirements: Record<string, boolean>;
}

export async function analyzeProposal(proposalId: string, clientId?: string) {
  return httpClient.post<AnalysisResponse>('/api/compliance/analyze-proposal', {
    proposal_id: proposalId,
    client_id: clientId,
  });
}
